<eo-base-form-control
  [labelVisible]="false"
  [canBeNotApplicable]="canBeNotApplicable"
  [notApplicableLabel]="notApplicableLabel"
  [notApplicable]="notApplicable"
  [errors]="getErrors()"
  (onRemove)="onRemoveHandler()"
  (onChange)="onChangeHandler($event)"
  (onBlur)="onBlurHandler($event)"
  (onFocus)="onFocusHandler($event)"
>
  <div class="flex gap-2">
    <p-checkbox
      [id]="id"
      [binary]="true"
      [tabindex]="getTabIndex()"
      [formControl]="getFormControl()"
      [value]="getValue()"
      (onRemove)="onRemoveHandler()"
      (onChange)="onChangeHandler($event)"
      (onBlur)="onBlurHandler($event)"
      (onFocus)="onFocusHandler($event)"
    />
    <eo-form-label
      *ngIf="isVisible()"
      [formId]="id"
      [label]="getLabel()"
      [required]="isRequired()"
    />
  </div>
</eo-base-form-control>
